var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"card shadow bg-gradient-secondary",attrs:{"shadow":"","no-body":""}},[_c('LessonInfoEdit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }